import NewsletterDialogController from './controllers/newsletter-dialog-controller'
import NewsletterInitiationFormController from './controllers/newsletter-initiation-form-controller'
import initPageOverlay from './init-page-overlay'
import domready from 'domready'

export default function initNewsletter () {
  domready(() => {
    const overlayController = initOverlayController()
    if (overlayController) {
      const newsletterDialogController = initNewsletterDialogController(overlayController)
      if (newsletterDialogController) {
      // Initiate Initiation forms
        initInitiationFormControllers(newsletterDialogController, overlayController)
      }
    }
  })
}

function initOverlayController () {
  // init OverlayController for popup
  const newsletterPopupElement = document.querySelector('.newsletter-popup')
  if (newsletterPopupElement) {
    return initPageOverlay(newsletterPopupElement)
  }
  return null
}

function initNewsletterDialogController (overlayController) {
  // init newsletter dialog
  const newsletterDialogContentContainerElement = document.querySelector('#newsletter-modal-dialog-content-container')
  if (newsletterDialogContentContainerElement) {
    const newsletterDialogController = new NewsletterDialogController(
      newsletterDialogContentContainerElement,
      {}
    )
    newsletterDialogController.initForm()

    // Close overlay when done
    newsletterDialogController.onDone(() => {
      overlayController.hide()
    })

    return newsletterDialogController
  }
  return null
}

function initInitiationFormControllers (newsletterDialogController, overlayController) {
  const newsletterInitiationFormElements = document.querySelectorAll('[data-newsletter-initiation]')
  ;[].forEach.call(newsletterInitiationFormElements, element => {
    const newsletterInitiationFormController = new NewsletterInitiationFormController(
      element,
      {}
    )

    // allow it to open the popup and prefill the email address
    newsletterInitiationFormController.onSubmitEmail(data => {
      if (overlayController) {
        overlayController.show()
      }

      const email = data.email ? data.email : null

      newsletterDialogController.initForm({ email: email })
    })

    // Empty the initiation form when the e-mail form was successfully submitted
    newsletterDialogController.onSuccess(() => {
      newsletterInitiationFormController.clear()
    })
  })
}
